module.exports = __webpack_public_path__ + "static/media/29COICT6.c88db459.jpg";